(() => {
 const pageId="nt3-hume-vsothers";
 const configs=()=>Array.from(document.getElementById(pageId)?.querySelectorAll('[data-nt-cart-config]')||[]);
 function match(target){return configs().find(c=>{const section=document.getElementById(c.dataset.ntSourceSection);return section?.contains(target)&&target.closest(c.dataset.ntCartSelector)})}
 function activate(event){
  if(event.type==='keydown'&&!['Enter',' '].includes(event.key))return;
  const config=match(event.target);if(!config)return;
  event.preventDefault();event.stopImmediatePropagation();
  const trigger=event.target.closest(config.dataset.ntCartSelector);
  if(trigger.getAttribute('aria-busy')==='true')return;
  const form=config.querySelector('form');const submit=form?.querySelector('[type="submit"]');
  let message=config.parentElement.querySelector('[data-nt-cart-status]');
  if(!message){message=document.createElement('div');message.dataset.ntCartStatus='';message.setAttribute('role','status');trigger.after(message)}
  if(!form||!submit||submit.disabled){message.textContent=config.dataset.ntUnavailable;return;}
  if(!customElements.get('product-form')){message.textContent=config.dataset.ntUnavailable;return;}
  message.textContent='';trigger.setAttribute('aria-busy','true');
  const observer=new MutationObserver(()=>{
   const error=config.querySelector('.product-form__error-message');if(error?.textContent)message.textContent=error.textContent;
   if(!submit.hasAttribute('aria-disabled')){trigger.removeAttribute('aria-busy');observer.disconnect();}
  });
  observer.observe(config,{subtree:true,attributes:true,childList:true,characterData:true});
  form.requestSubmit(submit);
 }
 document.addEventListener('click',activate,true);
 document.addEventListener('keydown',activate,true);
})();